import type { ConversationNodeAutoReply } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeAutoReply;
};

export function RoutedThroughAutoReply({ node }: Props): JSX.Element {
  return (
    <>
      Auto-reply · Template <strong>{node.auto_reply_template_id}</strong> sent
    </>
  );
}
